module.exports = __webpack_public_path__ + "static/media/warning.2628a860.svg";